import defaultFunctions from './functions.js';

// runFunctions запускает универсальные функции для всех билетных проектов.
// чтобы отключить функцию/функции в проекте
// необходимо передать объект с ключом функции и значением null
// пример runFunctions({ addEmailNoticeForQuickSignup: null });

const runFunctions = (disabledFunctions = {}) => {
	const functions = { ...defaultFunctions, ...disabledFunctions };
	const functionsKeys = Object.keys(functions);

	functionsKeys.forEach((key) => {
		if (typeof functions[key] === 'function') {
			functions[key]();
		}
	});
};

export default runFunctions;
